import React from 'react';
import PropTypes from 'prop-types';
import reportRenderError from '../../lib/reportRenderError';
import ErrorView from '../Error';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { name } = this.props;
    // Previously this built the payload inline and POSTed it itself, which bypassed
    // sendError's suppression list -- and its own fallback text, 'An error has occured',
    // had to be added to that list to stop the resulting feedback loop.
    reportRenderError(error, errorInfo?.componentStack, name);
  }

  render() {
    const { hasError } = this.state;
    const { children, fallback } = this.props;

    if (hasError) {
      return fallback ?? <ErrorView />;
    }
    return children;
  }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  /** Reported as the Component dimension, and the grouping key for render errors. */
  name: PropTypes.string,
  /** Overrides the default ErrorView. */
  fallback: PropTypes.node,
};
ErrorBoundary.defaultProps = {
  children: null,
  name: undefined,
  fallback: undefined,
};
